import { render } from "./HomeFooter.vue?vue&type=template&id=e77d4868"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__